<template>
  <figure class="picture" data-animation="picture">
    <img class="picture__image" :src="data.url" :alt="data.alt">
  </figure>
</template>

<script>
export default {
  name: 'appPicture',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  methods: {
    loadPicture(callback = () => {}) {
      return new Promise((resolve, reject) => {
        const img = this.$el.querySelector('.picture__img');
        const image = new Image();
        let src = '';

        src = img.getAttribute('data-src');

        image.src = src;

        img.removeAttribute('data-src');

        const errorHandler = () => {
          reject(new Error(`Failed to load image's URL: ${src}`));
        };

        const imageHandler = () => {
          image.removeEventListener('load', imageHandler);
          image.removeEventListener('error', errorHandler);
          img.src = image.src;
          image.remove();

          resolve();
        };

        image.addEventListener('load', imageHandler());
        image.addEventListener('error', errorHandler());
      }).then(callback());
    },
  },
};
</script>

<style lang="scss" scoped>
.picture {
  position: relative;
  margin: 0;
  padding: 0;

  background: $color-gradient-images;

  img {
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;

    mix-blend-mode: luminosity;
    opacity: 0.5;
  }
}
</style>
